import React from 'react';

/** Users icon with plus badge in the corner (does not overlap figures). */
function GroupAddIcon() {
  return (
    <>
      <svg
        className="groups-add-group-empty__users"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M19 3.13a4 4 0 0 1 0 7.75" />
      </svg>
      <span className="groups-add-group-empty__icon-plus" aria-hidden>
        +
      </span>
    </>
  );
}

/**
 * Empty org groups placeholder — dashed card with group icon and “Add a group”.
 */
const GroupsAddGroupEmptyState = ({ onClick, disabled = false, className = '' }) => {
  const interactive = Boolean(onClick) && !disabled;
  const Tag = interactive ? 'button' : 'div';

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      className={[
        'groups-add-group-empty',
        interactive ? 'groups-add-group-empty--interactive' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={interactive ? onClick : undefined}
      disabled={Tag === 'button' ? disabled : undefined}
      aria-label={interactive ? 'Add a group' : undefined}
      title={interactive ? 'Add a group' : undefined}
    >
      <span className="groups-add-group-empty__icon" aria-hidden>
        <GroupAddIcon />
      </span>
      <span className="groups-add-group-empty__label">Add a group</span>
    </Tag>
  );
};

export default GroupsAddGroupEmptyState;
